import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { environment } from '../../../../../environments/environment';
import { PARAMS } from 'src/app/_configs/params';
import { makeStateKey, TransferState } from '@angular/platform-browser';

@Component({
  selector: 'app-explore-by-keywords',
  templateUrl: './explore-by-keywords.component.html',
  styleUrls: ['./explore-by-keywords.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExploreByKeywordsTendersComponent implements OnInit {
  @Input() tenders: Array<any> = [];
  @Input() type: string = "";
  @Input() dataType: any;

  baseUrl: string = environment.TENDER.BASE_URL;
  imageBasePath: string = environment.TENDER.IMAGE_BASE_URL;
  slideConfig: any;
  isCurrentUserAgentIsMobile: boolean = false;
  isMobile: boolean = true;

  highValueTenders: Array<any> = [];
  tendersData: any[] | null = null;

  constructor(
    private transferState: TransferState,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute
  ) {
    this.resolveTenderMain();
  }

  ngOnInit(): void {
    this.preloadImages(); // Preload images when component initializes
  }

  /**
   * Navigate to all tenders page with full page reload
   * This bypasses Angular's internal routing and triggers a full page reload
   * to pull fresh data from the CDN instead of using cached data
   */
  navigateToAllTenders(event: Event) {
    event.preventDefault(); // Prevent default behavior
    // Use window.location.href to reload the page and pull fresh data from CDN
    window.location.href = '/all-tenders/keywords';
  }

  filterVisibleoOnMobile() {
    if (this.sharedService.isBrowser) {
      if (window.outerWidth < PARAMS.STATIC_PARAMS.WINDOWS_OUTER_WIDTH) {
        this.isMobile = false;
      }
    }
  }

  handleImageError(event: any): void {
    event.target.src = this.imageBasePath + 'banner/default.webp';
  }

  clickOnCard(type: string, tenderId: number) {
  }

  limit = 16; // Set the limit here

  resolveTenderMain() {
    this.activatedRoute.data.subscribe((rawData: any) => {
      let resolverData: any = rawData['tendersResolver'];

      if (resolverData && resolverData.keywords && Array.isArray(resolverData.keywords.data)) {
        this.highValueTenders = resolverData?.keywords?.data?.slice(0, this.limit);
      } else {
        this.highValueTenders = []; // Initialize with an empty array if no data is available
      }

      setTimeout(() => {
        if (!this.isMobile) {
          this.tendersData = this.highValueTenders?.slice(0, 4);
        } else {
          this.tendersData = this.highValueTenders;
        }
      }, 100);

      if (!resolverData) {
        const ALL_LISTING_KEYWORDS: any = makeStateKey<object>(PARAMS.STATIC_PARAMS.ALL_LISTING_KEYWORDS);

        this.sharedService.retrieveKeywordListTendersNew()
          .subscribe((res: any) => {
            if (res && Array.isArray(res.data)) {
              this.highValueTenders = res.data?.slice(0, this.limit);
            } else {
              this.highValueTenders = []; // Initialize with an empty array if no data is available
            }

            setTimeout(() => {
              if (!this.isMobile) {
                this.tendersData = this.highValueTenders?.slice(0, 4);
              } else {
                this.tendersData = this.highValueTenders;
              }
            }, 100);

            if (this.sharedService.isServer) {
              this.transferState.set(ALL_LISTING_KEYWORDS, this.highValueTenders);
            }
          });
      }
    });
  }

  private preloadImages(): void {
    if (this.tendersData && this.tendersData?.length) {
      this.tendersData.forEach((item: any) => {
        const imageUrl = item['link'] ? `${this.imageBasePath}${item['link']}.webp` : `${this.imageBasePath}banner/default.webp`;
        const img = new Image();
        img.src = imageUrl;
      });
    }
  }
}